import styled from '@emotion/styled';

import Button from 'components/field/Button';

export const CalculateGrandTotalButton = styled(Button)`
	position: absolute;
	top: 0.8rem;
	right: 9.5rem;

	body[dir='rtl'] & {
		right: unset;
		left: 9.5rem;
		top: 1.2rem;
	}
`;
